<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class="icon-list" />
      </template>
      <div class="sidebar tab-sidebar">
        <SidebarNav :navItems="nav"></SidebarNav>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import nav from "@/_nav_settings";
import { SidebarNav } from "@coreui/vue";
import CreateNavAccessCheck from "@/components/shared/mixins/CreateNavAccessCheck";

export default {
  name: "DefaultAside",
  mixins: [CreateNavAccessCheck],
  components: { SidebarNav },
  data() {
    return {
      nav: nav.items,
    };
  },
  mounted() {
    this.setUpNavItems();
  }
};
</script>
